var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 295,
    viewBox: "0 0 217 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7036 198.524H53.8534C29.2093 198.524 11.9712 182.63 7.87809 158.33L3 94.5",
    stroke: "#14151A",
    strokeWidth: 5.4628,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2048 293.609L77.5291 202.417C75.2215 191.947 65.9426 184.49 55.2217 184.49C44.3397 184.49 34.9695 192.166 32.8269 202.835L14.9736 293.609",
    stroke: "#14151A",
    strokeWidth: 1.8791,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.357 281.522L156.191 249.239L140.022 248.381L150.163 283.024L165.757 283.123L166.357 281.522Z",
    fill: "#FFBD9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.904 276.329C147.904 276.329 161.274 281.828 167.555 273.16L195.081 289.882L143.761 289.552L147.904 276.329Z",
    fill: "#14151A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.281 290.089L144.258 293.814L194.58 294.136L194.604 290.411L144.281 290.089Z",
    fill: "#FAFAFA",
    stroke: "#14151A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.219 280.475C167.362 280.417 167.494 280.32 167.593 280.19C169.693 277.438 171.803 276.079 171.824 276.066C172.24 275.802 172.352 275.266 172.075 274.868C171.797 274.472 171.228 274.375 170.821 274.627C170.724 274.688 168.434 276.155 166.126 279.175C165.831 279.561 165.922 280.1 166.328 280.38C166.596 280.566 166.935 280.591 167.219 280.475Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.636 282.685C171.78 282.626 171.912 282.529 172.011 282.399C174.111 279.647 176.22 278.289 176.242 278.275C176.657 278.011 176.77 277.476 176.492 277.08C176.214 276.684 175.644 276.581 175.236 276.839C175.139 276.899 172.849 278.366 170.542 281.386C170.247 281.772 170.338 282.312 170.743 282.591C171.013 282.776 171.353 282.801 171.636 282.685Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.053 284.892C176.197 284.833 176.329 284.736 176.428 284.606C178.528 281.854 180.637 280.496 180.659 280.482C181.074 280.218 181.187 279.683 180.909 279.285C180.631 278.889 180.061 278.786 179.655 279.044C179.558 279.104 177.268 280.571 174.96 283.589C174.665 283.974 174.757 284.515 175.162 284.795C175.428 284.983 175.768 285.008 176.053 284.892Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.399 155.719L123.452 156.611C133.352 157.24 141.769 164.062 144.436 173.617L166.458 258.441L135.943 255.601L111.342 181.091L109.399 155.719Z",
    fill: "#3284FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.566 262.396H170.419L167.863 248.809H131.01L133.566 262.396Z",
    fill: "#2E7BEF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.415 281.521L106.946 249.666L90.7789 248.809L91.2233 283.023L106.818 283.122L107.415 281.521Z",
    fill: "#FFBD9A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9647 276.329C88.9647 276.329 102.335 281.828 108.615 273.16L136.141 289.882L84.8211 289.552L88.9647 276.329Z",
    fill: "#14151A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3403 290.091L85.3165 293.816L135.639 294.138L135.663 290.413L85.3403 290.091Z",
    fill: "#FAFAFA",
    stroke: "#14151A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.279 280.475C108.423 280.417 108.555 280.32 108.654 280.19C110.754 277.438 112.863 276.079 112.885 276.066C113.3 275.802 113.412 275.266 113.135 274.868C112.857 274.472 112.289 274.375 111.879 274.627C111.782 274.688 109.492 276.155 107.185 279.175C106.891 279.561 106.981 280.1 107.386 280.38C107.656 280.566 107.996 280.591 108.279 280.475Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.696 282.683C112.84 282.624 112.972 282.527 113.071 282.397C115.171 279.645 117.28 278.287 117.302 278.273C117.717 278.009 117.829 277.474 117.552 277.078C117.274 276.682 116.704 276.579 116.298 276.837C116.201 276.897 113.911 278.364 111.603 281.384C111.308 281.77 111.4 282.31 111.805 282.589C112.071 282.774 112.413 282.799 112.696 282.683Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.114 284.892C117.257 284.833 117.389 284.736 117.488 284.606C119.588 281.854 121.698 280.496 121.719 280.482C122.134 280.218 122.247 279.683 121.969 279.285C121.692 278.889 121.121 278.786 120.714 279.044C120.617 279.104 118.327 280.571 116.019 283.589C115.724 283.974 115.815 284.515 116.221 284.795C116.489 284.983 116.828 285.008 117.114 284.892Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.96 154.213L66.9227 155.965L99.7531 156.637C109.335 156.637 117.143 162.415 117.284 171.996C117.723 201.454 115.446 262.674 114.061 262.396C112.19 262.022 85.2806 262.396 85.2806 262.396L82.5441 195.507L61.4594 197.801C56.2639 197.844 41.0753 198.824 36.4407 196.476C26.8454 191.614 14.601 180.229 22.96 154.213Z",
    fill: "#5196FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1306 248.809H118.984V262.396H82.1306V248.809Z",
    fill: "#3284FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5439 195.506L83.0543 180.525",
    stroke: "#55382C",
    strokeWidth: 0.8439,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.511 101.962L168.178 93.1299C168.178 93.1299 182.594 92.0663 191.353 93.9721C192.271 94.172 192.855 95.0707 192.634 95.9848C192.44 96.7941 191.673 97.3316 190.846 97.2404L182.759 96.3554L187.114 99.3171C188.294 100.119 188.162 101.898 186.875 102.516C186.34 102.774 185.715 102.766 185.195 102.477C182.774 101.14 175.17 97.6519 167.757 101.823L174.672 104.93C176.032 105.541 176.399 107.303 175.396 108.408C174.912 108.938 174.202 109.2 173.49 109.108L167.054 108.274C167.054 108.274 159.483 111.358 152.473 107.992L150.511 101.962Z",
    fill: "#87FCD5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8422 79.127C98.4394 92.8328 106.443 120.13 106.443 120.13L150.66 99.3053L156.508 114.484L118.994 140.099L77.9602 138.387L74.919 106.294L92.8422 79.127Z",
    fill: "#87FCD5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4593 70.1895C88.4249 72.4252 91.2293 75.3675 92.8421 79.1268L95.499 155.72C95.499 155.72 48.4912 165.618 22.9601 154.212C22.9601 154.212 23.6801 90.065 38.2225 73.089C38.2225 73.089 42.8047 64.0721 66.1116 64.0313C73.0441 64.0177 79.9223 66.0148 85.4593 70.1895Z",
    fill: "#87FCD5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5914 92.832L86.2009 146.609",
    stroke: "#79B19E",
    strokeWidth: 0.7349,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.048 137.258L135.695 124.055C135.695 124.055 140.428 114.171 144.745 114.031C147.912 113.928 151.906 116.077 154.025 118.328C154.988 119.351 154.73 120.996 153.476 121.631C151.421 122.671 148.29 124.529 146.693 126.838C146.693 126.838 148.781 137.489 145.257 141.873C143.464 144.103 132.91 146.607 132.91 146.607L135.048 137.258Z",
    fill: "#87FCD5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2527 76.7305L71.7262 130.424L135.429 133.184V155.717L66.9227 154.059C64.3065 154.213 62.3211 153.372 60.9043 151.903L60.2095 152.231C60.2095 152.231 41.6556 152.544 36.4427 89.1962L63.2527 76.7305Z",
    fill: "#87FCD5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.492 132.929L71.7088 130.319L64.8365 86.7715",
    stroke: "#79B19E",
    strokeWidth: 0.7349,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7086 130.318L62.8916 132.929",
    stroke: "#79B19E",
    strokeWidth: 0.7349,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7296 106.16L44.1555 134.831C45.7722 142.045 49.6867 148.539 55.3092 153.339L58.1893 155.615",
    stroke: "#79B19E",
    strokeWidth: 0.7349,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9468 14.963C96.9468 14.963 95.3573 22.5398 96.9468 27.155C98.5363 31.7702 103.592 33.94 101.323 45.9942C99.0526 58.0485 101.475 58.3338 102.02 61.7379C102.02 61.7379 53.6225 66.2949 29.384 53.8661C29.384 53.8661 33.483 46.8327 38.0225 39.0288C42.562 31.2248 44.268 18.3924 44.268 18.3924L62.8277 11.2891L96.9468 14.963Z",
    fill: "#954B55"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4552 6.01939C86.0083 5.84666 83.856 2.65795 83.3048 2.48134C74.6897 -0.270702 56.2851 -3.91164 46.9267 11.2207C40.0485 22.3414 46.9538 43.2554 61.4088 49.5862C75.1787 55.6163 72.8343 9.9689 72.8343 9.9689L85.4552 6.01939Z",
    fill: "#954B55"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9367 34.3436C81.4864 38.0893 84.1589 41.4915 87.9046 41.9418C91.6503 42.392 95.0525 39.7195 95.5028 35.9738C95.953 32.2281 93.2806 28.8259 89.5348 28.3757C85.7872 27.9254 82.3869 30.5978 81.9367 34.3436Z",
    fill: "#FFB1A7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5864 52.595L77.8979 67.3877C77.3157 72.5832 73.8029 75.0033 68.6928 74.3881C64.3318 73.8641 60.5046 71.1198 60.4832 66.7278L64.26 43.5762L79.5864 52.595Z",
    fill: "#FFC9BD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5423 61.7398C68.1649 60.8412 62.8278 45.9961 62.8278 45.9961L79.7903 51.0849L78.5423 61.7398Z",
    fill: "#C6877F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9497 54.7655C83.7162 55.2313 91.3028 48.6908 91.9238 41.5449L93.2882 24.6755C94.0665 15.7188 87.6017 7.7596 78.676 6.68635C69.5388 5.58786 59.6388 11.9129 58.5403 21.0501L57.5913 34.6298C56.8538 45.1334 63.7125 53.9077 74.9497 54.7655Z",
    fill: "#FFC9BD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.702 18.8833C69.865 25.0978 63.0684 33.9187 63.0684 33.9187L50.2281 18.3943C50.2281 18.3943 63.2372 15.2017 65.702 18.8833Z",
    fill: "#954B55"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5021 32.285C49.0518 36.0307 51.7243 39.433 55.47 39.8832C59.2157 40.3335 62.6179 37.661 63.0682 33.9153C63.5185 30.1695 60.846 26.7673 57.1002 26.3171C53.3526 25.8668 49.9524 28.5393 49.5021 32.285Z",
    fill: "#FFC9BD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4124 35.4024C58.4124 35.4024 59.0024 30.4844 54.2087 30.694",
    stroke: "#14151A",
    strokeWidth: 0.5621,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5997 38.9922L83.7317 41.0009L81.7443 41.0048",
    stroke: "#14151A",
    strokeWidth: 0.5621,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7251 26.6952C73.7251 26.6952 77.5251 26.5458 77.5116 27.7685C77.5116 27.7685 77.4727 28.5953 74.1579 28.6749C70.843 28.7544 69.9929 28.541 69.7232 27.7569C69.4553 26.9728 71.9454 26.6583 73.7251 26.6952Z",
    fill: "#793641"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8903 27.1926C88.8903 27.1926 85.7715 26.8568 85.4668 27.998C85.4668 27.998 85.2843 28.7704 88.015 29.0169C90.7476 29.2614 91.6501 29.0091 91.9354 28.3881C92.2595 27.6855 90.375 27.2488 88.8903 27.1926Z",
    fill: "#793641"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2495 34.666C77.2495 34.666 75.5552 32.2458 72.417 34.5864",
    stroke: "#14151A",
    strokeWidth: 0.7051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2412 35.1592C90.2412 35.1592 88.7332 32.7604 86.6313 35.002",
    stroke: "#14151A",
    strokeWidth: 0.7051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4498 44.581C80.4498 44.581 77.8589 45.1944 75.7531 42.5859",
    stroke: "#14151A",
    strokeWidth: 0.7051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3049 2.48235C83.3049 2.48235 102.024 9.24016 98.1441 16.2833C95.2698 21.5021 76.4325 24.7393 58.5385 21.0538C58.5385 21.0538 50.3716 14.4221 60.4831 7.54974C60.4831 7.54974 65.9096 -0.120247 83.3049 2.48235Z",
    fill: "#954B55"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0546 68.5615C83.0546 68.5615 77.7155 65.1108 69.8514 64.0297C69.8514 64.0297 60.4638 63.4533 52.6017 65.3126C52.6017 65.3126 53.1179 73.658 68.9237 75.5018C72.0309 75.8647 75.1983 75.7871 78.2065 74.9351C81.2302 74.0811 81.9444 71.9831 83.0546 68.5615Z",
    fill: "#FFC9BD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7233 152H127V146H78.7233C77.2193 146 76 147.343 76 149C76 150.657 77.2193 152 78.7233 152Z",
    fill: "#061418"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M119.602 151.996H196.611C200.704 151.996 204.296 149.267 205.395 145.323L216.584 90.7559C217.141 88.753 215.635 86.7715 213.558 86.7715H135.639C133.937 86.7715 132.448 87.9185 132.016 89.5643L119.602 151.996Z",
    fill: "#1C2E34"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.375 120.641C163.375 124.356 166.385 127.366 170.1 127.366C173.812 127.366 176.825 124.356 176.825 120.641C176.825 116.926 173.814 113.916 170.1 113.916C166.385 113.916 163.375 116.926 163.375 120.641Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M141 159.18V294.608",
    stroke: "#55382E",
    strokeWidth: 1.1466,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64 152H217V166H64V152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/Girl.6a2f9be1623efdbe5d0b20e5c47674f8.svg";
export { ForwardRef as ReactComponent };